import React from 'react';
import { Tabs, Tab, Box, Button } from '@mui/material';
import InsuranceForm from '../components/forms/InsuranceForm';
import LoanForm from '../components/forms/LoanForm';
import RentForm from '../components/forms/RentForm';
import BillForm from '../components/forms/BillForm';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import bg from '../assets/banner.jpg'; // Your background image

function FormPage() {
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box display="flex">
      {/* Sidebar stays on the left */}
      <Sidebar />

      {/* Full right section with background image */}
      <Box
        flexGrow={1}
        ml={30}
        sx={{
          minHeight: '100vh',
          backgroundImage: `url(${bg})`,
          backgroundAttachment: 'fixed',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          p: 4,
          color: '#fff', // makes all text white
          overflowY: 'auto',
        }}
      >
        <Tabs
  value={value}
  onChange={handleChange}
  textColor="inherit"
  TabIndicatorProps={{
    style: { backgroundColor: '#e0b256' }, // 👈 custom indicator color
  }}
  sx={{
    backgroundColor: 'rgba(0,0,0,0.5)',
    borderRadius: 2,
    mb: 1,
  }}
>

          <Tab label="Insurance Policy" />
          <Tab label="Loan Payment" />
          <Tab label="Rent Payment" />
          <Tab label="Utility Bill & Credit Card" />
        </Tabs>

        {/* Form Section */}
        <Box
          sx={{
            backgroundColor: 'rgba(0,0,0,0.5)',
            borderRadius: 2,
            p: 3,
          }}
        >
          {value === 0 && <InsuranceForm />}
          {value === 1 && <LoanForm />}
          {value === 2 && <RentForm />}
          {value === 3 && <BillForm />}
        </Box>

        {/* Back Button */}
        <Button
          variant="outlined"
          onClick={() => navigate('/dashboard')}
          sx={{
            mt: 3,
            color: '#fff',
            borderColor: '#fff',
            '&:hover': {
              backgroundColor: 'rgba(255,255,255,0.1)',
              borderColor: '#fff',
            },
          }}
        >
          Back to Dashboard
        </Button>
      </Box>
    </Box>
  );
}

export default FormPage;
